import { useEffect, useState } from "react";
import { getApi } from "../../ApiServices/api";
import { apiEndPoints } from "../../ApiServices/config";

const usePujaSamagri = () => {
  const [pujaSamagri, setPujaSamagri] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const handleDownload = (url) => {
      fetch(url)
        .then((response) => response.blob())
        .then((blob) => {
          const url = window.URL.createObjectURL(new Blob([blob]));
          const link = document.createElement("a");
          link.href = url;
          link.download = "PujaSamagri.pdf";
          document.body.appendChild(link);
  
          link.click();
  
          document.body.removeChild(link);
          window.URL.revokeObjectURL(url);
        })
        .catch((error) => {
          console.error("Error fetching the file:", error);
        });
    };

  const fetchPujaSamagri = async () => {
    try {
      const response = await getApi(apiEndPoints.allPujaSamagri);
      if (response && response.status === 200) {
        setPujaSamagri(response.data);
      } else {
        setError("Failed to fetch data");
      }
    } catch (err) {
      console.error("Error fetching Puja Samagri:", err);
      setError(err.message || "Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchPujaSamagri();
  }, []);

  return { pujaSamagri, loading, error, handleDownload };
};

export default usePujaSamagri;
